import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
  const ptHome = e.target.querySelector('.pt-home')

  if (ptHome) {
    const jsProjectsSlider = ptHome.querySelector('.js-projects-slider')

    if (jsProjectsSlider) {
      const splideInstance = new Splide(jsProjectsSlider, {
        perPage: 4,
        perMove: 1,
        gap: '20px',
        arrows: false,
        pagination: false,
        breakpoints: {
          667: {
            perPage: 1,
            fixedWidth: '320px',
            gap: '10px',
          },
          996: {
            fixedWidth: '355px',
            perPage: 2,
            gap: '20px',
          },
          1800: {
            fixedWidth: '450px',
            perPage: 3,
          },
        },
      })

      splideInstance.mount()

      const jsHeaderSlider = ptHome.querySelector('.js-header-slider')
      if (jsHeaderSlider) {
        var main = new Splide(jsHeaderSlider, {
          type: 'fade',
          heightRatio: 0.5,
          pagination: false,
          arrows: false,
          autoplay: true,
          cover: true,
        })
        main.mount()
      }
    }
  }
})
